export default "__VITE_ASSET__DexadfTd__"